module.exports = __webpack_public_path__ + "00d49c154a504c5179faf81503cea763.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/home/components/images/dialogue-two.png
 ** module id = 1565
 ** module chunks = 0
 **/